var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttention2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.003,
    height: 14,
    viewBox: "0 0 14.003 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1016",
    "data-name": "Rectangle 1016",
    width: 14.003,
    height: 14,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Attention",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2737",
    "data-name": "Group 2737",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M13.452,4.3a7.227,7.227,0,0,0-1.517-2.238A7.036,7.036,0,0,0,9.7.544,6.779,6.779,0,0,0,7,0,6.747,6.747,0,0,0,4.3.544,7.154,7.154,0,0,0,.549,4.293a6.928,6.928,0,0,0,0,5.411A7.211,7.211,0,0,0,4.3,13.449,6.7,6.7,0,0,0,7.006,14a6.712,6.712,0,0,0,2.7-.551A7.18,7.18,0,0,0,13.456,9.7a6.93,6.93,0,0,0,0-5.409m-2.22,6.922a5.994,5.994,0,0,1-1.9,1.281,5.851,5.851,0,0,1-2.325.462A5.845,5.845,0,0,1,4.684,12.5a5.974,5.974,0,0,1,0-11h0A5.848,5.848,0,0,1,7,1.037a5.965,5.965,0,0,1,4.23,10.18M6.422,7.611,6.328,4.159a.6.6,0,0,1,.18-.468.665.665,0,0,1,.483-.18.676.676,0,0,1,.483.183.6.6,0,0,1,.187.472l-.1,3.445A.508.508,0,0,1,7,8.18a.533.533,0,0,1-.126,0,.513.513,0,0,1-.451-.57m1.16,1.6a.707.707,0,0,1-.039,1A.774.774,0,0,1,7,10.414v0a.759.759,0,0,1-.537-.209c-.013-.013-.026-.025-.038-.038a.7.7,0,0,1,.035-.992A.754.754,0,0,1,7,8.959a.774.774,0,0,1,.544.209c.013.013.026.025.039.039",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention2);
export default __webpack_public_path__ + "static/media/Attention2.7bba5b33d93ad2217faf75895f9356f2.svg";
export { ForwardRef as ReactComponent };